'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var TextLink = require('@narvar/nth-bit-text-link');
var mustache = require('mustache');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var MustacheNestedRender = require('@narvar/nth-bit-mustache-nested-render');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var MustacheNestedRender__default = /*#__PURE__*/_interopDefaultLegacy(MustacheNestedRender);

const templateLinkContext = (href, style) => {
  const ALink = ({
    children
  }) => /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    key: href,
    linkStyle: {
      sDefault: {
        color: style?.color,
        fontSize: 'inherit',
        lineHeight: 'inherit'
      }
    },
    href: href || ''
  }, children);
  return ALink;
};
let Channels = /*#__PURE__*/function (Channels) {
  Channels["SMS"] = "sms";
  Channels["EMAIL"] = "email";
  Channels["HIPAA_SMS"] = "hipaa_sms";
  Channels["HIPAA_EMAIL"] = "hipaa_email";
  Channels["APP_PUSH"] = "app_push";
  Channels["LINE"] = "line";
  return Channels;
}({});
let PreferenceLevels = /*#__PURE__*/function (PreferenceLevels) {
  PreferenceLevels["TRACKING"] = "TRACKING";
  PreferenceLevels["ORDER"] = "ORDER";
  PreferenceLevels["RETAILER"] = "RETAILER";
  PreferenceLevels["ORDER_ONLY"] = "ORDER_ONLY";
  return PreferenceLevels;
}({});
const NotificationCenterDisclaimerText = ({
  notificationChannel,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled
}) => {
  const {
    captiontextDefaultNone,
    linksNoneDefault,
    linksTrackingDefault: linkStyle,
    linksTrackingHover: linkHoverStyle
  } = nthHookTheme.useTheme();
  const [disclaimerTextVisible, setDisclaimerTextVisible] = React.useState(false);
  const {
    notificationCenter
  } = nthHookSettings.useSettings();
  const {
    enableEmailDisclaimerText = null,
    toggleDisclaimerText = false,
    marketingOptInEnabled = false,
    marketingOptInPrivacyLink,
    marketingOptInTermsLink
  } = notificationCenter || {};
  const {
    notificationCenterSmsDisclaimerText = '',
    notificationCenterSmsDisclaimerTextMarketing = '',
    notificationCenterSmsDisclaimerLinkLabel = '',
    notificationCenterSmsDisclaimerTextRetailerLevel = '',
    notificationCenterEmailDisclaimerText = '',
    notificationCenterEmailDisclaimerLinkLabel = '',
    notificationCenterEmailDisclaimerTextRetailerLevel = '',
    notificationCenterLineDisclaimerText = '',
    notificationCenterLineDisclaimerLinkLabel = '',
    notificationCenterSublimeDisclaimerCopy = ''
  } = nthHookTranslations.useTranslations();
  const smsDisclaimerText = marketingOptInEnabled ? notificationCenterSmsDisclaimerTextMarketing : notificationCenterSmsDisclaimerText;
  const {
    retailerLevelOptInEnabled,
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    preferenceLevel
  } = notificationPreferencesState || {};
  const retailerLevel = retailerLevelOptInEnabled && (preferenceLevel === PreferenceLevels.RETAILER || preferenceLevel === PreferenceLevels.ORDER);
  const smsDisclaimerChannelProps = {
    channelTextEnabled: true,
    disclaimerText: retailerLevel ? notificationCenterSmsDisclaimerTextRetailerLevel || '' : smsDisclaimerText || '',
    disclaimerTextLinkLabel: notificationCenterSmsDisclaimerLinkLabel || ''
  };
  const emailDisclaimerChannelProps = {
    channelTextEnabled: enableEmailDisclaimerText,
    disclaimerText: retailerLevel ? notificationCenterEmailDisclaimerTextRetailerLevel || '' : notificationCenterEmailDisclaimerText || '',
    disclaimerTextLinkLabel: notificationCenterEmailDisclaimerLinkLabel || ''
  };

  // TODO: Add retailer level disclaimer text
  const lineDisclaimerChannelProps = {
    channelTextEnabled: true,
    disclaimerText: notificationCenterLineDisclaimerText || '',
    disclaimerTextLinkLabel: notificationCenterLineDisclaimerLinkLabel || ''
  };
  const appleWalletDisclaimerChannelProps = {
    channelTextEnabled: false,
    disclaimerText: '',
    disclaimerTextLinkLabel: ''
  };
  const disclaimerChannelProps = {
    [Channels.SMS]: smsDisclaimerChannelProps,
    [Channels.HIPAA_SMS]: smsDisclaimerChannelProps,
    [Channels.EMAIL]: emailDisclaimerChannelProps,
    [Channels.HIPAA_EMAIL]: emailDisclaimerChannelProps,
    [Channels.APP_PUSH]: appleWalletDisclaimerChannelProps,
    [Channels.LINE]: lineDisclaimerChannelProps
  };
  if (!disclaimerChannelProps[notificationChannel]) return null;
  const {
    channelTextEnabled = false,
    disclaimerText = '',
    disclaimerTextLinkLabel = ''
  } = disclaimerChannelProps[notificationChannel];

  // if flag isn't set (i.e., null | undefined), set default to true
  const disclaimerTextEnabled = typeof channelTextEnabled === 'boolean' ? channelTextEnabled : true;
  if (!disclaimerText || !disclaimerTextEnabled) return null;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, !toggleDisclaimerText && !consumerPreferencesOptinEnabled && /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    onClick: () => setDisclaimerTextVisible(!disclaimerTextVisible),
    linkStyle: {
      sDefault: linkStyle,
      sHover: linkHoverStyle
    }
  }, disclaimerTextLinkLabel), (toggleDisclaimerText || disclaimerTextVisible) && /*#__PURE__*/React__default["default"].createElement("p", {
    style: {
      fontSize: 'inherit',
      margin: 0,
      padding: toggleDisclaimerText || consumerPreferencesOptinEnabled ? 0 : '1rem 0 0 0',
      textAlign: 'left',
      ...captiontextDefaultNone
    }
  }, consumerPreferencesOptinEnabled ? /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
    template: mustache__default["default"].parse(notificationCenterSublimeDisclaimerCopy ?? ''),
    context: new mustache__default["default"].Context({
      termsLink: () => templateLinkContext('https://corp.narvar.com/profile-terms-of-service', linksNoneDefault),
      privacyLink: () => templateLinkContext('https://corp.narvar.com/profile-privacy-policy', linksNoneDefault)
    })
  }) : /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
    template: mustache__default["default"].parse(disclaimerText ?? ''),
    context: new mustache__default["default"].Context({
      termsLink: () => templateLinkContext(marketingOptInTermsLink ?? '', linksNoneDefault),
      privacyLink: () => templateLinkContext(marketingOptInPrivacyLink ?? '', linksNoneDefault),
      retailerName
    })
  })));
};
var index = nthHookSettings.withSettingsProvider(nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(NotificationCenterDisclaimerText, {
  themeTokens: ['captiontextDefaultNone', 'linksNoneDefault', 'linksTrackingDefault', 'linksTrackingHover']
}), {
  translationKeys: ['notificationCenterSmsDisclaimerText', 'notificationCenterSmsDisclaimerTextMarketing', 'notificationCenterSmsDisclaimerLinkLabel', 'notificationCenterSmsDisclaimerTextRetailerLevel', 'notificationCenterEmailDisclaimerText', 'notificationCenterEmailDisclaimerLinkLabel', 'notificationCenterEmailDisclaimerTextRetailerLevel', 'notificationCenterLineDisclaimerText', 'notificationCenterLineDisclaimerLinkLabel', 'notificationCenterSublimeDisclaimerCopy']
}), {
  globalSettingsRequested: `
      retailerLevelOptInEnabled
      retailerName
    `
}), {
  settingsRequested: `
      notificationCenter {
        enableEmailDisclaimerText
        toggleDisclaimerText
        marketingOptInEnabled
        marketingOptInPrivacyLink
        marketingOptInTermsLink
      }
    `
});

exports.Channels = Channels;
exports.PreferenceLevels = PreferenceLevels;
exports["default"] = index;
